import React, { Component } from 'react'
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
import CAHeader from '../../components/header/CAHeader';
import Responsive from '../../components/Responsive';
import { checkTranslation, conditionalWidth, priceStandardView, translate } from '../../utils/useful';
import StagesManager from '../../components/StagesManager';
import FormViewer from '../../components/FormViewer';
import HttpServices from '../../utils/Http.services';
import SwitchInput from '../../components/inputs/SwitchInput';
import HelpButton from '../../components/HelpButton';
import CommerceCart from './CommerceCart';
import { duration } from 'jalali-moment';
import Modal from '../../components/Modal';
import NumberInput from '../../components/inputs/NumberInput';
import PriceInput from '../../components/inputs/PriceInput';
import { siteConfig } from '../../variables/config';

export default class SubscriptionPage extends Component {
    state = {
        display: true,
        // duration: "yearly",
        data: {},
        currentPlan: "Team",
        pricingData: [

            // {
            //     title: '{{lang}}Starter', key: 'starter', desc: '{{lang}}The essentials to get your team up and running',
            //     price: { monthly: 0, yearly: 0 }, users: '{{lang}}Up to 5 users',
            //     buttons: [{ title: '{{lang}}Select', function: '', status: 0 }],
            //     level: 0,
            //     options: {
            //         list: [
            //             { text: '{{lang}}Up to 5 licenses', desc: '{{lang}}Any user and hub needs a valid license to be able to have access to any private applet. User perspective of Public applets does not need license for access.' },
            //             { text: '{{lang}}5 GB cloud storage' },
            //             { text: '{{lang}}Unlimited connections', desc: '{{lang}}Unlimited users and businesses can connect to your hub and applets based on the limitations you setup.' },
            //             { text: '{{lang}}Up to 10 applets' },
            //             { text: '{{lang}}Up to 10,000 records per collection' },
            //             { text: '{{lang}}up to 10 frames per applet' },
            //             // '{{lang}}Up to 60 minutes meeting duration',
            //         ]
            //     }
            // },


            // {
            //     title: '{{lang}}Team', key: 'team', desc: '{{lang}}The essentials to get your team up and running',
            //     price: { monthly: 35, yearly: 29 }, users: '{{lang}}Up to 50 users',
            //     buttons: [{ title: '{{lang}}Select', function: '', status: 0 }],
            //     level: 1,
            //     options: {
            //         list: [
            //             { text: '{{lang}}Up to 50 licenses', desc: '{{lang}}Any user and hub needs a valid license to be able to have access to any private applet. User perspective of Public applets does not need license for access.' },
            //             { text: '{{lang}}5 GB cloud storage per license', desc: '{{lang}}The total storage will be available for the whole hub and the storage will not be alocated to users. e.g. 30 licenses will give your hub 150 GB cloud storage.' },
            //             { text: '{{lang}}Unlimited connections', desc: '{{lang}}Unlimited users and businesses can connect to your hub and applets based on the limitations you setup.' },
            //             { text: '{{lang}}Up to 100 applets' },
            //             { text: '{{lang}}Unlimited records per collection' },
            //             { text: '{{lang}}Unlimited frames per applet' },
            //             // '{{lang}}Can connect emails',

            //         ]
            //     }
            // },

            // {
            //     title: '{{lang}}Professional', key: 'professional', desc: '{{lang}}Advanced tools to take your growing team to the next level',
            //     price: { monthly: 47, yearly: 39 }, users: '{{lang}}Up to 5000 users',
            //     buttons: [{ title: '{{lang}}Select', function: '', status: 2 }],
            //     level: 2,
            //     options: {
            //         title: '{{lang}}Everything in Starter, plus:', list: [
            //             { text: '{{lang}}Up to 5,000 licenses', desc: '{{lang}}Any user and hub needs a valid license to be able to have access to any private applet. User perspective of Public applets does not need license for access.' },
            //             { text: '{{lang}}10 GB cloud storage per license', desc: '{{lang}}The total storage will be available for the whole hub and the storage will not be alocated to users. e.g. 3000 licenses will give your hub 15 TB cloud storage.' },
            //             { text: '{{lang}}Unlimited connections', desc: '{{lang}}Unlimited users and businesses can connect to your hub and applets based on the limitations you setup.' },
            //             { text: '{{lang}}Unlimited applets' },
            //             { text: '{{lang}}Unlimited records per collection' },
            //             { text: '{{lang}}Unlimited frames per applet' },
            //         ]
            //     }
            // },
            // {
            //     title: '{{lang}}Enterprise', key: 'enterprise', desc: '{{lang}}More features and data to transform your team',
            //     priceLabel: "{{lang}}Let's talk", users: '{{lang}}Unlimited users',
            //     buttons: [{ title: '{{lang}}Contact sales', function: '', status: 1, isContact: true }],
            //     options: {
            //         title: '{{lang}}Everything in Pro, plus:', list: [
            //             { text: '{{lang}}Unlimited licenses', desc: '{{lang}}Any user and hub needs a valid license to be able to have access to any private applet. User perspective of Public applets does not need license for access.' },
            //             { text: '{{lang}}Custom cloud storage' },
            //             { text: '{{lang}}Unlimited connections', desc: '{{lang}}Unlimited users and businesses can connect to your hub and applets based on the limitations you setup.' },
            //             { text: '{{lang}}Unlimited applets' },
            //             { text: '{{lang}}Unlimited records per collection' },
            //             { text: '{{lang}}Unlimited frames per applet' },
            //         ]
            //     }
            // },
        ],

        headers: [
            { key: 'invoice', type: 'InvoiceInput2', information: { required: true, placeholder: '{{lang}}Quantity', } },
        ],

        formHeaders: [
            { key: 'country', type: 'TextInput', col: '6', information: { label: '{{lang}}Country/Region', required: true, placeholder: '{{lang}}Country', } },
            { key: 'province', type: 'TextInput', col: '6', information: { label: '{{lang}}Province/State', required: true, placeholder: '{{lang}}Province', } },
            { key: 'city', type: 'TextInput', col: '6', information: { label: '{{lang}}City', required: true, placeholder: '{{lang}}City', } },
            { key: 'zipcode', type: 'NumberInput', col: '6', information: { label: '{{lang}}Zip Code', required: true, placeholder: '{{lang}}Zip Code', type: 'api', address: 'searchUser', filter: {}, fields: { title: 'fullname', value: '_id', description: 'username', image: 'image' } } },
            { key: 'company', type: 'TextInput', col: '6', information: { label: '{{lang}}Company', required: true, placeholder: '{{lang}}Company', } },
            { key: 'address', type: 'TextInput', col: '6', information: { label: '{{lang}}Address', required: true, placeholder: '{{lang}}Address', } },
            { key: 'taxId', type: 'NumberInput', col: '6', information: { label: '{{lang}}Tax ID', required: false, placeholder: '{{lang}}Tax ID', } },
        ],

        priceHeaders: [
            { key: 'quantity', col: '6', type: 'NumberInput', information: { required: true, placeholder: '{{lang}}Quantity', label: '{{lang}}Quantity', } },
            // { key: 'service', col: '6', type: 'NumberInput', information: { required: true, placeholder: '{{lang}}Service period', label: '{{lang}}Service period (by Year)', } },
            { key: 'serviceTime', col: '6', type: 'SelectInput', information: { required: true, items: [{ title: '{{lang}}Monthly', value: 'monthly' }, { title: '{{lang}}Yearly', value: 'yearly' }], placeholder: '{{lang}}Service period', label: '{{lang}}Service period (by Year)', } },
            { key: 'subscription', col: '12', type: 'SwitchInput', information: { placeholder: '{{lang}}Subscription', label: '{{lang}}Subsctiption', } },
        ]
    }

    componentDidMount() {
        // if (this.props.setHeader) {
        //     this.props.setHeader({
        //         'toolbar': null,
        //         'showToolbar': false,
        //         'info': 'Create Hub | Pricing',
        //         topHeaderComponent: this.topHeaderComponent,
        //         backAction: () => this.props.changePage(['accountSettings'])
        //     })
        // }
        if (this.props.initData?.license?.quantity) {
            this.setState({ quantity: this.props.initData?.license?.quantity })
        }

        this.fetchPriceData()

    }


    fetchPriceData = () => {

        let body = {
            applet: siteConfig.yonnectSunscriptionApplet,
            appletHub: siteConfig.yonnectHub
        }
        console.log("body", body)
        HttpServices.request('getProducts', body, (fetchResult, fetchError) => {

            console.log(fetchResult)
            if (fetchError) {
                return
            }

            let currentPlan = this.state.currentPlan
            let currentLevel
            let pricingData = fetchResult.info
            pricingData = pricingData.filter(el => el.type == 'membership')
            console.log('pricingData', pricingData)
            let prices = {}
            let priceDurations = []
            let pricingConfig = {}
            let currentDuration
            let sort = ['Starter', 'Team', 'Professional', 'Enterprise']
            let showSaving = true

            pricingData.sort((a, b) => sort.indexOf(a.name) - sort.indexOf(b.name));



            pricingData.forEach((element, index) => {

                if (element.name == currentPlan) {
                    currentLevel = index
                }



                if (element.priceType == 'subscription') {
                    if (Array.isArray(element.subscriptionPrice)) {

                        prices[element._id] = {}


                        element.subscriptionPrice.forEach(sprice => {


                            prices[element._id][(sprice.repeat ?? '1') + "-" + sprice.duration] = { price: sprice.price, duration: sprice.duration, repeat: sprice.repeat }

                            let found = false
                            priceDurations.forEach(pduration => {
                                if (pduration.duration == sprice.duration && pduration.repeat == sprice.repeat) {
                                    found = true
                                }
                            });

                            if (!found) {
                                let label = sprice.duration
                                if ((sprice.repeat ?? 1) == 1) {
                                    if (sprice.duration == 'year') {
                                        label = '{{lang}}Yearly'
                                    }
                                    if (sprice.duration == 'month') {
                                        label = '{{lang}}Monthly'
                                    }
                                    if (sprice.duration == 'week') {
                                        label = '{{lang}}Weekly'
                                    }
                                } else {
                                    label = `${sprice.repeat} ${sprice.duration}s`
                                }

                                priceDurations.push({ duration: sprice.duration, repeat: sprice.repeat, key: (sprice.repeat ?? '1') + "-" + sprice.duration, label })

                            }

                        })
                    }
                }

            })

            if (priceDurations.length > 0) {
                let samePricing = true

                priceDurations.forEach(pDuration => {

                    if (!currentDuration) {
                        currentDuration = pDuration
                    } else {

                        if (currentDuration.duration == 'week' && ((pDuration.duration == 'month' || pDuration.duration == 'year') || (pDuration.duration == 'week' && (pDuration.repeat ?? 1 > (currentDuration.repeat ?? 1))))) {
                            currentDuration = pDuration
                        }

                        if (currentDuration.duration == 'month' && ((pDuration.duration == 'year') || (pDuration.duration == 'month' && (pDuration.repeat ?? 1 > (currentDuration.repeat ?? 1))))) {
                            currentDuration = pDuration
                        }

                        if (currentDuration.duration == 'year' && ((pDuration.duration == 'year' && (pDuration.repeat ?? 1 > (currentDuration.repeat ?? 1))))) {
                            currentDuration = pDuration
                        }

                    }

                    if (currentDuration.duration == 'year') {
                        showSaving = true
                    }

                    pricingData.forEach(element => {

                        if (element.priceType == 'subscrition') {
                            let found = false
                            element.subscriptionPrice.forEach(sprice => {
                                if (pDuration.duration == sprice.duration && pDuration.repeat == sprice.repeat) {
                                    found = true
                                }
                            })

                            if (!found) {
                                samePricing = false
                            }
                        }
                    })

                })

                pricingConfig.samePricing = samePricing
            }

            if (priceDurations.length == 2) {

                pricingConfig.showSwitch = true

            }

            if (priceDurations.length > 1 && showSaving) {
                pricingConfig.showSaving = true
            }


            let durationSort = ['week', 'moth', 'year']

            priceDurations.sort((a, b) => durationSort.indexOf(a.duration) - durationSort.indexOf(b.duration) || (a.repeat ?? 1) - (b.repeat ?? 1));



            // console.log(priceDurations)
            // console.log(pricingConfig)
            // console.log(prices)

            this.setState({ pricingData, pricesInfo: prices, priceDurations, pricingConfig, currentLevel, currentDuration })



        })
    }

    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static'
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }

    topHeaderComponent = () => {
        return (
            <div className='flexc'>
                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.checkOut}
                    isLoading={this.state.isLoading}
                    title={translate("{{lang}}Check Out")}
                    icon='/assets/icons/angle-right-white2.svg'
                    textColor={'#222'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />
            </div>
        )
    }
    checkOut = () => {
        // console.log('this.props.data', this.props)
        let data = this.priceForm.getForm()
        let billing = this.form.getForm()
        if (data && billing) {
            // console.log('firstdata', data)
            // let body = { quantity: data?.quantity, serviceType: data?.serviceType, subscription: data?.subscription, expiry: { value: data?.service, unit: 'year' } }
            let body = { ...{ serviceInfo: data }, ...billing }
            HttpServices.request('checkoutWithStripe', body, (fetchResult, fetchError) => {
                if (fetchError) {
                    return
                }
                // console.log('fetchResult', fetchResult.info.url)
                window.location.href = fetchResult.info.url
            })
        }
    }
    nextClicked = (status, serviceType) => {
        // console.log('nextClicked', serviceType)
        let data = this.state.data
        data.serviceType = serviceType
        console.log(data)
        // this.props.
        // this.setState({ data, status }, () => {
        //     this.stageManager.changeStage("review")
        // })
        // if (status == 0) {
        //     if (this.props.initData?.category) {
        //         this.props.changeStage("info")
        //     }
        // }
        // else {
        //     this.props.setStatus(2, () => {
        //         data.serviceType = serviceType
        //         this.props.setData(data, () => {
        //             this.props.changeStage("pricingInfo")
        //         })
        //     })
        // }
        // else {
        //     this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.ContentEmpty' })
        // }
    }

    setSubscription = (item, quantity) => {
        let license = { plan: item._id, planInfo: item, duration: this.state.currentItem?.duration, repeat: this.state.currentDuration?.repeat, quantity }
        this.props.setData({ license }, () => {
            this.props.afterSet(item)
        })
    }

    changeType = (prop, index) => {
        this.props.setData({ category: prop.name }, () => {
        })
    }

    toggleDisplay = () => {
        this.setState(prevState => ({
            display: !prevState.display
        }))
    }

    openLicenseCount = (item) => {
        this.setState({ currentItem: item }, () => {
            this.countModal.showModal()
        })
    }

    render() {
        let variables = this.props.variables
        return (
            <div className=" w-100 " style={{}}>
                <StagesManager height={'100%'} ref={el => this.stageManager = el} >
                    <div stage={0} stagName={'type'} className=' w-100 flexc flex-column px-2' style={{ height: 'calc(100% - 46px)', }} >
                        <div className='px-1 br-10 w-100 text-start ' style={{ maxWidth: 800 }}>
                            <div className='flexcb flex-wrap mb-3 px-2 pt-4'>
                                <div>
                                    <p className=' mb-1 font-size-18 weight-700 main-c2'>Compare plans</p>
                                    <p className='   font-size-14 weight-500 main-c2'>Select the one which is more suitable for you</p>
                                </div>

                                {this.state.pricingConfig?.showSwitch && Array.isArray(this.state.priceDurations) && (
                                    <div className='flexcc mb-10 my-3'>
                                        <button>
                                            {/* <p className='text-small text-semibold '>{translate("Monthly")}</p> */}
                                            <p className='text-small text-semibold '>{translate(this.state.priceDurations[0]?.label)}</p>

                                        </button>
                                        <div className='flexc mx-2'>
                                            <SwitchInput data={this.state.currentDuration?.key == this.state.priceDurations[1]?.key} changeValue={(key, value) => this.setState({ currentDuration: value ? this.state.priceDurations[1] : this.state.priceDurations[0] })} header={{ information: {} }} />
                                        </div>
                                        <button>
                                            <p className='text-small text-semibold '>{translate(this.state.priceDurations[1]?.label)}</p>
                                        </button>
                                    </div>
                                )}
                            </div>


                            <div className={"h-100 w-100 " + conditionalWidth(this.props.width, { xs: "scale-pricing2", sm: "scale-pricing2", md: "scale-pricing2", lg: 'scale-pricing2', xl: 'scale-pricing2' })} style={{}}>
                                <div className=" m-0 p-0">
                                    <div className="d-flex flex-wrap">
                                        {Array.isArray(this.state.pricingData) && this.state.pricingData.map((item, index) => {

                                            let title = 'Upgrade'
                                            let bg = `linear-gradient(90deg, rgb(88, 86, 214), rgb(124, 122, 255))`
                                            let invert = false
                                            let textColor = '#fff'
                                            let border
                                            let onClick = "setSubscription"
                                            let icon = '/assets/icons/angle-right-white2.svg'
                                            if (item.priceType != 'contact') {
                                                if (this.props.type == 'update') {
                                                    title = '{{lang}}Upgrade'
                                                    if (this.state.currentLevel > index) {
                                                        title = '{{lang}}Downgrade'
                                                    }
                                                    if (this.state.currentLevel == index) {
                                                        title = '{{lang}}Current plan'
                                                        bg = `linear-gradient(90deg, #ddd, #ddd)`
                                                        textColor = '#505050'
                                                        invert = true
                                                        icon = false
                                                        onClick = null
                                                    }
                                                } else {
                                                    if (item.priceType == 'free') {
                                                        title = '{{lang}}Try for free'
                                                        onClick = "setSubscription"
                                                    } else {
                                                        title = '{{lang}}Purchase'
                                                        bg = `linear-gradient(90deg, rgb(88, 86, 214), rgb(124, 122, 255))`
                                                        textColor = '#fff'
                                                        invert = false
                                                        onClick = "openLicenseCount"

                                                    }
                                                }
                                            } else {
                                                border = '1px solid rgb(88, 86, 214)'
                                                textColor = 'rgb(88, 86, 214)'
                                                title = '{{lang}}Contact sales'
                                                bg = `#fff`
                                                invert = true
                                                icon = false
                                                onClick = "openContactSales"
                                            }



                                            return (
                                                <Responsive className={' d-flex  px-1'} width={this.props.width} media={{ xs: "12", sm: '6', md: '6', lg: "3", xl: "3" }}>
                                                    <div className={('w-100 mb-4')} >
                                                        <div className={" w-100 ch-pricing-box d-flex flex-column h-100 px-3 py-4"} style={{ backgroundColor: '#fff' }} >
                                                            <div className="">
                                                                <p className="mb-1 font-size-20 text-bold" >{checkTranslation(item.name)}</p>
                                                            </div>
                                                            <div className="d-flex w-100" style={{}}>

                                                                {item.priceType == 'contact' && (
                                                                    <p className="" style={{ fontSize: '30px', textAlign: 'start', fontWeight: 700, }}>{checkTranslation(("Let's Talk"))}</p>
                                                                )}

                                                                {item.priceType == 'free' && (
                                                                    <p className="" style={{ fontSize: '30px', textAlign: 'start', fontWeight: 700, }}>{checkTranslation(("Free"))}</p>
                                                                )}
                                                                {/* {console.log('this.state.pricesInfo', this.state.pricingData)} */}

                                                                {item.priceType == 'subscription' && this.state.pricesInfo && this.state.pricesInfo[item._id] && (
                                                                    <>
                                                                        <p className='text-bold mrd-1 ' style={{ marginTop: 6 }}>USD</p>
                                                                        <p className="" style={{ fontSize: '30px', textAlign: 'start', fontWeight: 700, }}>{this.state.pricesInfo[item._id][this.state.currentDuration?.key]?.price > 0 ? this.state.pricesInfo[item._id][this.state.currentDuration?.key]?.price : translate('Free')}</p>
                                                                    </>
                                                                )}
                                                                {!item.priceType && (
                                                                    <>
                                                                        <p className='text-bold mrd-1 ' style={{ marginTop: 6 }}>USD</p>
                                                                        <p className="" style={{ fontSize: '30px', textAlign: 'start', fontWeight: 700, }}>{item.price?.final > 0 ? item.price?.final : translate('Free')}</p>
                                                                    </>
                                                                )}


                                                                {/* {(item.price != null && item.price[this.state.duration] > 0) && (
                                                                    <p className='text-bold mrd-1 ' style={{ marginTop: 6 }}>USD</p>
                                                                )}
                                                                {item.price ? (
                                                                    <p className="" style={{ fontSize: '30px', textAlign: 'start', fontWeight: 700, }}>{item.price[this.state.duration] > 0 ? item.price[this.state.duration] : translate('Free')}</p>
                                                                ) : (
                                                                    <p className="" style={{ fontSize: '30px', textAlign: 'start', fontWeight: 700, }}>{checkTranslation((item.priceLabel))}</p>
                                                                )} */}

                                                                {/* {item.payment &&
                                                                    <p className="mld-2" style={{ fontSize: '24px', textAlign: 'start', fontWeight: 300, lineHeight: '24px' }}>{translate('/')}</p>
                                                                } */}
                                                                <p className="" style={{ fontSize: '18px', textAlign: 'start', fontWeight: 700, }}>{checkTranslation(item.payment)}</p>
                                                            </div>
                                                            <p className="" style={{ fontSize: '14px', textAlign: 'start', fontWeight: 400, }}>{translate('per license per month')}</p>
                                                            {(this.state.pricingConfig.showSaving && item.priceType == 'subscription') ? (
                                                                <p className='text-small mt-2' style={{ color: "rgb(8, 98, 209)" }}>Save 18% annually</p>
                                                            ) : (
                                                                <p className='text-small mt-2' style={{ color: "rgb(8, 98, 209)", height: 19 }}></p>
                                                            )}
                                                            {/* <p className="mt-2 text-semibold" style={{ fontSize: '14px', textAlign: 'start', }}>{checkTranslation(item.users)}</p> */}
                                                            <div className=' flexcb mt-3 br-10 w-100'>
                                                                {/* {item.buttons.map((button, bindex) => { */}





                                                                <div className={' flexc w-100'}>
                                                                    <ButtonAnimated
                                                                        iconwidth='24px'
                                                                        onClick={() => onClick ? this[onClick](item) : null}
                                                                        isLoading={this.state.isLoading}
                                                                        title={checkTranslation(title)}
                                                                        width={'100%'}
                                                                        icon={icon}
                                                                        textColor={textColor}
                                                                        invert={invert}
                                                                        border={border}
                                                                        bg={bg}
                                                                    />
                                                                </div>



                                                            </div>

                                                            {/* <p className="mt-3 mb-3" style={{ fontSize: '15px', textAlign: 'start', lineHeight: '1.5em', fontWeight: 500, }}>{checkTranslation(item.desc)}</p> */}


                                                            <div className="d-flex flex-column w-100 mt-3" style={{ textAlign: 'start' }}>
                                                                {/* {item.options.title &&
                                                                    <p className="" style={{ fontSize: '15px', textAlign: 'start', fontWeight: 500, }}>{checkTranslation(item.options.title)}</p>
                                                                } */}
                                                                {Array.isArray(item.benefits) && item.benefits.map((prop, pindex) => {
                                                                    return (
                                                                        <div className='flexc pb-2' style={{ alignItems: 'start' }}>
                                                                            <div className='mrd-2 flexcc'>
                                                                                {prop.description ? (
                                                                                    <HelpButton data={prop.description} />
                                                                                ) : (
                                                                                    <div className='flexcc pld-1'>
                                                                                        <img src='/assets/icons/useful/checkmark.png' width={18} alt='' />
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                            <p className="d-flex" style={{ fontSize: '13px', textAlign: 'start', }}>{checkTranslation(prop.title)}</p>
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Responsive>
                                            )
                                        })}


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div stage={1} stageName={'pricingInfo'} className=" w-100 h-100  position-relative window-content-radius" style={{}}>
                        <CommerceCart stageName={'cart'} language={this.props.language} getCart={this.getCart} addToCart={this.addToCart} cart={this.state.cart} windowData={this.props.windowData} colors={this.props.colors} changePage={this.changePage} baseUrl={[...this.props.baseUrl]} setHeader={this.setHeader} applet={this.props.applet} pages={this.state.pages} width={this.props.width} height={this.props.height} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} changeWindowLink={this.changeWindowLink} addNotif={this.addNotif} history={this.props.history} route={this.props.route} variables={variables} />
                    </div> */}
                    {/* <div stage={1} stageName={'pricingInfo'} className=" w-100 h-100  position-relative window-content-radius" style={{}}>
                        <div className={'d-flex scroll-no-scrollbar ' + (conditionalWidth(this.props.width, { xs: 'flex-column', lg: 'flex-row' }))} style={{ height: 'calc(100% - 46px)', padding: '4% 6%', background: "rgba(245, 228, 255, 35%)" }}>
                            <Responsive className={" px-2 py-2 " + (conditionalWidth(this.props.width, { xs: '', lg: 'h-100' }))} width={this.props.width} media={{ xs: '12', sm: '12', md: '12', lg: "7", xl: "8" }}>
                                <div className=' w-100 flexc h-100 flex-column' style={{}} >
                                    {Array.isArray(this.state.pricingData) && this.state.pricingData.map((item, index) => {
                                        return (
                                            <>
                                                {item.buttons.map((buttun, bindex) => {
                                                    if (buttun.status == this.state.status) {
                                                        return (
                                                            <div className='br-10 w-100 px-3' style={{ background: '#fff' }}>
                                                                <div className='flexcb pt-4 '>
                                                                    <p className='font-size-16 weight-600 main-c2'>{translate('Product')}</p>
                                                                    <p className='font-size-16 weight-600 main-c2'>{translate('Hub')} {checkTranslation(item.title)}</p>
                                                                </div>
                                                                <div className="br-10 my-3" style={{ border: '1px solid #eee' }}>
                                                                    <div className='brt-10 px-4 py-3' style={{ background: this.props.colors ? this.props.colors?.background : '#f9f9f9', }}>
                                                                        <p style={{ color: this.props.colors ? this.props.colors?.textColor : '#222' }}>{translate('Hub')} {checkTranslation(item.title)}</p>
                                                                    </div>
                                                                    <div className="d-flex flex-column w-100 pt-3" style={{ textAlign: 'start' }}>
                                                                        {item.options.list.map((prop, pindex) => {
                                                                            return (
                                                                                <div className='flexc pb-3 px-4' style={{ alignItems: 'start' }}>
                                                                                    <img src='/assets/icons/tick-pricing.svg' className='mrd-2' />
                                                                                    <p className="" style={{ color: 'rgb(100, 106, 115)', fontSize: '13px', textAlign: 'start', fontWeight: 500, }}>{checkTranslation(prop.text)}</p>
                                                                                </div>
                                                                            )
                                                                        })}
                                                                    </div>
                                                                </div>
                                                                <div className="py-3 px-4">
                                                                    <div className='flexcb pb-2'>
                                                                        <FormViewer ref={el => this.priceForm = el} headers={this.state.priceHeaders} errors={this.state.errors} inputClass={'modern-input'} nopadding={true} setData={this.props.setData} />
                                                                    </div>
                                                                </div>
                                                                <div className='py-4 mt-3 px-4' style={{ borderTop: '1px solid #eee' }}>
                                                                    <div className='flexcb pb-2'>
                                                                        <p className='font-size-14 weight-600 main-c2'>{translate('Billing Information')}</p>
                                                                    </div>
                                                                    <div>
                                                                        <FormViewer ref={el => this.form = el} headers={this.state.formHeaders} errors={this.state.errors} inputClass={'modern-input'} nopadding={true} setData={this.props.setData} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                })
                                                }

                                            </>

                                        )
                                    })}
                                </div>
                            </Responsive>
                            <Responsive className={" px-2 py-2 " + (conditionalWidth(this.props.width, { xs: '', lg: 'h-100' }))} width={this.props.width} media={{ xs: '12', sm: '12', md: '12', lg: "5", xl: "4" }}>
                                <div className='br-10 w-100' style={{ background: '#fff' }}>
                                    <div className='brt-10 px-4 py-3' style={{ background: this.props.colors ? this.props.colors?.background : '#f9f9f9', }}>
                                        <p style={{ color: this.props.colors ? this.props.colors?.textColor : '#222' }}>{translate('Order Summery')}</p>
                                    </div>
                                    <div className="py-3 px-4">
                                        <FormViewer ref={el => this.orderForm = el} headers={this.state.headers} errors={this.state.errors} inputClass={'modern-input-pricing'} nopadding={true} setData={this.props.setData} />
                                    </div>
                                </div>
                            </Responsive>
                        </div>
                    </div> */}
                </StagesManager>


                <Modal ref={el => this.countModal = el} maxWidth={400}>
                    <div className="w-100 h-100 " style={{ backgroundColor: '#fff', borderRadius: 8 }}>
                        <div className="w-100 px-3 py-2 flexc top-0" style={{ zIndex: 1, position: 'sticky', borderBottom: '1px solid #f2f2f2', backgroundColor: '#fff', borderRadius: '8px 8px 0px 0px' }}>
                            <img src='/assets/icons/applets/general/diamond-award.png' height={20} alt='' />
                            <p className='text-bold text-normal py-1 px-1'>{translate("Licenses quantity")}</p>

                        </div>
                        {/* {this.state.currentItem?.priceType == 'subscription' && this.state.pricesInfo && this.state.pricesInfo[this.state.currentItem?._id] && ( */}

                        <div className='pt-3 px-3'>
                            <p className=' text-small'>{translate("How many licenses do you want to purchase? you can change this number later.")}</p>

                            <div className='bordered-input w-100 mt-3 flexc big-text px-2'>
                                <PriceInput data={this.state.quantity} changeValue={(key, value) => { this.setState({ quantity: value }) }} header={{ information: { placeholder: '{{lang}}Licenses quantity' } }} />
                            </div>
                            {this.state.quantity != null && this.state.quantity > 0 && (
                                <>
                                    {/* <div className='mt-3 px-1 flexce' style={{}}>
                                            <p className='text-smaller text-semibold'><span className='text-smaller'>USD</span> {this.state.currentItem?.price?.final} ✕ {this.state.quantity} = {this.state.currentDuration?.duration == 'year' && (<span className='text-bold'>USD {this.state.currentItem?.price?.final * this.state.quantity}</span>)} / month</p>
                                        </div>

                                        <div className='flexcb  px-1 mt-1'>
                                            <p className='text-bold text-normal'>{translate("Subtotal price")}</p>
                                            <p className='text-bold text-normal' style={{ color: 'rgb(88, 86, 214)' }}><span className='text-smaller'>USD</span> {priceStandardView((this.state.quantity * this.state.currentItem?.price?.final * (this.state.currentDuration?.duration == 'year' ? 12 : 1)))} / <span style={{ textTransform: 'capitalize' }}>{translate(this.state.currentDuration?.duration)}</span></p>
                                        </div> */}
                                    <div className='mt-3 px-1 flexce' style={{}}>
                                        <p className='text-smaller text-semibold'><span className='text-smaller'>USD</span> {this.state.currentItem?.price?.final} ✕ {this.state.quantity} = {this.state.currentItem?.duration == 'year' && (<span className='text-bold'>USD {this.state.currentItem?.price?.final * this.state.quantity}</span>)} / month</p>
                                    </div>

                                    <div className='flexcb  px-1 mt-1'>
                                        <p className='text-bold text-normal'>{translate("Subtotal price")}</p>
                                        <p className='text-bold text-normal' style={{ color: 'rgb(88, 86, 214)' }}><span className='text-smaller'>USD</span> {priceStandardView((this.state.quantity * this.state.currentItem?.price?.final * (this.state.currentItem?.duration == 'year' ? 12 : 1)))} / <span style={{ textTransform: 'capitalize' }}>{translate(this.state.currentItem?.duration)}</span></p>
                                    </div>


                                    <div className='flexce mt-3'>

                                        <ButtonAnimated
                                            iconwidth='24px'
                                            onClick={() => this.setSubscription(this.state.currentItem, this.state.quantity)}
                                            isLoading={false}
                                            title={checkTranslation("Continue")}
                                            // width={'100%'}
                                            icon={'/assets/icons/angle-right-white2.svg'}
                                            textColor={'#fff'}
                                            invert={false}
                                            bg={'linear-gradient(90deg, rgb(88, 86, 214), rgb(124, 122, 255))'}
                                        />
                                    </div>
                                </>
                            )}
                            {/* <div className='flexce mt-0 px-1'>
                                <p className='text-bold text-normal' style={{ color: '#007aff' }}>{translate("Annually")}</p>
                            </div> */}

                        </div>
                        {/* )} */}
                    </div>
                </Modal>

            </div>
        )
    }
}
